/*
posibles tipos:
- multi
- selector
- listaNumeros
- fecha
- rangoFecha
 */

export default {
  titulo: 'Documentos emitidos',
  campos: ['EstadosEmision', 'NCND', 'MontoTotal', 'DocumentoAduana', 'TrackId', 'FechaEnvioSii', 'FechaEmision'],
  acccionesIndividuales: ['Bitacora', 'DescargarAmbosPdf', 'DescargarXml', 'AnularDocumento'],
  // acccionesIndividuales: ['DescargarPdf'],
  accionesMasivas: [],
  seleccionMasiva: true,
  categoria: 'emitidos',
  filtrosFijos: [
    { campo: 'incompleto', valor: 'N' }
  ],
  filtrosPorDefecto: [
    { campo: 'tipoDocumento', tipo: 'multi', valor: [33, 34, 61, 52, 56] },
    { campo: 'estadoSii', tipo: 'multi', valor: [1, 2, 3, 4, 5, 6, 9] },
    { campo: 'rutEmisor', tipo: 'multi', valor: ['60804000-5', '60804010-2', '60804002-1', '60804008-0'] }
  ],
  filtrosHabilitados: [
    { campo: 'fechaEmision', tipo: 'rangoFecha' },
    {
      campo: 'rutEmisor',
      tipo: 'multi',
      opciones: [
        { nombre: '60804000-5 (Central)', valor: '60804000-5' },
        { nombre: '60804010-2 (Metropolitana)', valor: '60804010-2' },
        { nombre: '60804002-1 (Iquique)', valor: '60804002-1' },
        { nombre: '60804008-0 (Valparaiso)', valor: '60804008-0' }
      ]
    },
    { campo: 'folio', tipo: 'numero' },
    { campo: 'rutReceptor', tipo: 'rut' },
    {
      campo: 'estadoSii',
      tipo: 'multi',
      opciones: [
      // {nombre:'Creado',valor:'0'},
        { nombre: 'Pendiente de Envío', valor: '1' },
        { nombre: 'Enviado', valor: '2' },
        { nombre: 'Error al enviar', valor: '3' },
        { nombre: 'Aceptado', valor: '4' },
        { nombre: 'Aceptado con reparos', valor: '5' },
        { nombre: 'Rechazado', valor: '6' },
        // {nombre:'Pendiente de consulta',valor:'7'},
        // {nombre:'Error al consultar',valor:'8'},
        { nombre: 'Ensobrado', valor: '9' },
      // {nombre:'Anulado',valor:'10'},
      // {nombre:'Pendiente validación',valor:'20'},
      ]
    },
    {
      campo: 'tipoDocumento',
      tipo: 'multi',
      opciones: [
        { valor: '33', nombre: 'Facturas Afectas' },
        { valor: '34', nombre: 'Facturas Exentas' },
        { valor: '52', nombre: 'Guías de Despacho' },
        { valor: '56', nombre: 'Notas de Débito' },
        { valor: '61', nombre: 'Notas de Crédito' }
      ]
    },
    {
      campo: 'estadoComercial',
      tipo: 'multi',
      opciones: [
        { valor: '0', nombre: 'Sin acción' },
        { valor: '1', nombre: 'Pre-Aceptado' },
        { valor: '2', nombre: 'Aceptado en el SII' },
        { valor: '3', nombre: 'Pre-Rechazado' },
        { valor: '4', nombre: 'Rechazado en el SII' },
        { valor: '5', nombre: 'Reclamo parcial en el SII' },
        { valor: '6', nombre: 'Reclamo total en el SII' },
        { valor: '7', nombre: 'Recibo de mercaderías en el SII' },
      ]
    },
  ]
};
